import actionTypes from '../../action-types'

export default (payload) => ({
  type: actionTypes.USER.UPDATE,
  payload,
})
